import { useContext, useEffect, useState } from "react";

import { DropdownValue } from "components/Actions/dialogs/types/interfaces";
import ParamsContext from "context/params/paramsContext";
import { API_IS_BEING_CANCELLED } from "shared/constants/strings";
import { sortAndReturnArray } from "shared/functions";
import { useApi } from "shared/hooks/useApi";
import { useIsMounted } from "shared/hooks/useIsMounted";
import { ENDPOINTS, FILTER_NAMES } from "shared/types/enums";

export const usePackages = () => {
    const { queryParams } = useContext(ParamsContext);

    const { cancelSource, isCanceled, getData, handleResponse } = useApi();
    const isMounted = useIsMounted();

    const [isLoading, setIsLoading] = useState(true);
    const [packages, setPackages] = useState<DropdownValue[]>([]);

    useEffect(() => {
        const getPackages = async () => {
            try {
                const rootParams = `${FILTER_NAMES.RootCompany}=${queryParams[FILTER_NAMES.RootCompany]}`;

                const { data } = await getData(
                    `${ENDPOINTS.CanAdapters}/packages?${rootParams}`
                );

                const sortedData = sortAndReturnArray(
                    data as DropdownValue[],
                    "name"
                );

                if (isMounted) {
                    setPackages(sortedData);
                    setIsLoading(false);
                }
            } catch (error) {
                if (isMounted && !isCanceled(error)) {
                    handleResponse(error);
                    setIsLoading(false);
                }
            }
        };

        getPackages();

        return () => {
            cancelSource.cancel(API_IS_BEING_CANCELLED);
        };
        // eslint-disable-next-line
    }, []);

    return { isLoading, packages };
};
